"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.progressBarSize = exports.spinnerSize = exports.loadersNovoDark = exports.loadersNovo = exports.loaders = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const timing_const_1 = __importDefault(require("../choices/timing.const"));
const { novo, novoDark } = oxygen_theme_1.default;
const loaders = {
    backgroundContainer: color_const_1.default.cloudyBlue100,
    backgroundFiller: color_const_1.default.dodgerBlue,
    backgroundComplete: novo.success01,
    borderSize: size_const_1.default.borderSizeDefault,
    borderStyle: 'solid',
    borderColor: color_const_1.default.cloudyBlue300,
    borderRadius: size_const_1.default.borderSizeLarge,
    color: color_const_1.default.pickledBluewood800,
    fontFamily: font_const_1.default.family,
    fontSize: font_const_1.default.sizeSm,
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: font_const_1.default.weightAttention,
    lineHeight: font_const_1.default.lineHeightSm,
    letterSpacing: 'normal',
    height: size_const_1.default.default,
    transitionSpeedSpinner: timing_const_1.default.slow,
    transitionSpeedProgressBar: timing_const_1.default.medium,
    withSpinnerBackground: true,
    widthSpinnerSmall: parseInt(size_const_1.default.medium, 10),
    widthSpinnerDefault: parseInt(size_const_1.default.large, 10),
    widthSpinnerExtraLarge: parseInt(size_const_1.default.large2x, 10),
    widthProgressBarSmall: '100px',
    widthProgressBarDefault: '240px',
    widthProgressBarLarge: '100%',
};
exports.loaders = loaders;
const loadersNovo = {
    ...loaders,
    ...novo.body01,
    withSpinnerBackground: false,
    borderStyle: 'none',
    borderRadius: '8px',
    height: '8px',
    widthSpinnerSmall: 24,
    widthSpinnerDefault: 40,
    widthSpinnerExtraLarge: 72,
    widthProgressBarSmall: '100px',
    widthProgressBarDefault: '240px',
    widthProgressBarLarge: '100%',
    color: novo.textColor01,
    backgroundContainer: novo.ui01,
    backgroundFiller: novo.action04,
    backgroundComplete: novo.success01,
};
exports.loadersNovo = loadersNovo;
const loadersNovoDark = {
    ...loadersNovo,
    color: novoDark.textColor01,
    backgroundContainer: novoDark.ui01,
    backgroundFiller: novoDark.action04,
    backgroundComplete: novoDark.success01,
};
exports.loadersNovoDark = loadersNovoDark;
/**
 * @deprecated
 */
const spinnerSize = {
    small: 'small',
    default: 'default',
    large2x: 'large2x',
};
exports.spinnerSize = spinnerSize;
/**
 * @deprecated
 */
const progressBarSize = {
    small: 'small',
    default: 'default',
    large: 'large',
};
exports.progressBarSize = progressBarSize;
